import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
const Container = styled.div `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.85);
    padding: 0.5rem;
    text-align: center;
    z-index: 9999;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
`;
const Message = styled.p `
    margin: 0;
    color: #ffffff;
    font-size: 0.875rem;
    font-weight: 400;
`;
const Link = styled.a `
    color: #ffffff;
`;
export const NotSupportedMessage = ({ children, }) => {
    return (_jsx(Container, { children: _jsx(Message, { children: children }) }));
};
export const GenericBrowserNotSupported = () => {
    return (_jsx(NotSupportedMessage, { children: "This application works best in the Chrome browser. Firefox does not yet support the underlying HEVC (H.265) or AVC (H.264) codecs used in StreamrTV." }));
};
export const FirefoxNotSupported = () => {
    return (_jsx(NotSupportedMessage, { children: "This application works best in the Chrome browser. Firefox does not yet support audio processing in worker threads." }));
};
export const CodecNotSupported = () => {
    return (_jsx(NotSupportedMessage, { children: "Your device does not support the underlying HEVC (H.265) or AVC (H.264) codecs used in StreamrTV. Support for your device is coming soon!" }));
};
export const CodecNotInstalled = () => {
    return (_jsxs(NotSupportedMessage, { children: ["It looks like your device is missing the HEVC (H.265) video codec. You can install it from the", ' ', _jsx(Link, { href: "https://apps.microsoft.com/detail/9n4wgh0z6vhq?hl=en-US&gl=US", target: "_blank", rel: "noopener noreferrer", children: "Microsoft Store" }), "."] }));
};
